// extracted by mini-css-extract-plugin
export default {"dropdown":"HXkUlxgi"};